import useCapabilities, { useCanViewPersonDocumentsBool } from "@/hooks/useCapabilities";

/** Capability check for person Documents. Denied users are redirected to person overview. */
export function usePersonDocumentsAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonDocuments = useCanViewPersonDocumentsBool();

  return {
    loaded,
    canViewPersonDocuments
  };
}
